import { z } from 'zod';
import type { DimensionToken, DimensionType } from '@sleed/bizcommerce-api';

/**
 * Dimension edit form. Mirrors `DimensionToken` and the legacy admin grid
 * (Core/client/admin/src/pages/Catalog/Dimensions/index.js): nm required ≤100, dt (DimensionType)
 * required, erpcd (ERP sync code) optional ≤50, iv boolean, si required. `dt` is a lookup over DimensionsApi.getDimensionTypes
 * (EnumToken id→name). Individual values are managed in the per-dimension values sub-grid. flt (BW-8412): a Custom
 * dimension shows as a storefront filter only when set.
 */
export const dimensionSchema = z.object({
	id: z.number().optional(),
	nm: z.string().trim().min(1, 'validation.required').max(100, 'validation.tooLong'),
	dt: z.number({ message: 'validation.required' }),
	erpcd: z.string().trim().max(50, 'validation.tooLong').nullable(),
	flt: z.boolean(),
	iv: z.boolean(),
	si: z.number({ message: 'validation.required' }).int()
});

export type DimensionFormValues = z.infer<typeof dimensionSchema>;

export const EMPTY_DIMENSION: DimensionFormValues = {
	nm: '',
	dt: 0,
	erpcd: '',
	flt: false,
	iv: true,
	si: 0
};

export function tokenToForm(token: DimensionToken): DimensionFormValues {
	return {
		id: token.id,
		nm: token.nm ?? '',
		dt: (token.dt as number | undefined) ?? 0,
		erpcd: token.erpcd ?? '',
		flt: token.flt ?? false,
		iv: token.iv ?? false,
		si: token.si ?? 0
	};
}

export function formToToken(form: DimensionFormValues): DimensionToken {
	return {
		id: form.id,
		nm: form.nm.trim(),
		dt: form.dt as DimensionType,
		erpcd: form.erpcd?.trim() || null,
		flt: form.flt,
		iv: form.iv,
		si: form.si
	};
}
